<template>
  <el-container id="scene">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-main class="div_main" style="background:#FFFFFF;padding:15px;width:100%;margin-top:0">
      <!--        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">-->
      <!--          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">-->
      <!--            <el-input-->
      <!--                placeholder="输入名称查询"-->
      <!--                style="width:10vw;"-->
      <!--                prefix-icon="el-icon-search"-->
      <!--                clearable-->
      <!--                @change="getScene()"-->
      <!--                v-model="scan_name">-->
      <!--            </el-input>-->
      <!--          </span>-->
      <!--        </div>-->
      <div class="grid-box1" :style="divStyle">
        <div class="grid-item1" v-for="(site,item) in sites" :style="{background:site.bj}">
          <div style="width:100%;line-height:0.3;font-size:15px;margin-left:15px;">
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <p style="width:40%;height:10px;font-size:16px;margin-top:5px;margin-bottom:5px">
                {{ site.name }}
              </p>
              <el-switch
                  v-model="site.isAppointing"
                  @change="changeNotice(site,'isAppointing')"
                  style="margin-left:auto;margin-right:10px">
              </el-switch>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:20px;height:16px;margin-right:10px;"
                          :src="yy1"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                {{ site.startTime }} - {{ site.endTime }}
              </p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:16px;height:16px;margin-right:10px;"
                          :src="yy2"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                提前开门时间：{{ site.earlyTime }}分钟
              </p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:14px;height:16px;margin-right:10px;"
                          :src="yy3"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                最远可预约：{{ site.earlyDay }}天
              </p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:20px;height:16px;margin-right:10px;"
                          :src="yy4"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">时间段：{{ site.timeGap }}分钟/场</p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:16px;height:16px;margin-right:10px;"
                          :src="yy6"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                清洁时长：{{ site.cleanTime }}分钟
              </p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:16px;height:16px;margin-right:10px;"
                          :src="yy8"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                仅限业主预约：
              </p>
              <el-switch
                  v-model="site.onlyOwer"
                  @change="changeNotice(site,'onlyOwer')"
                  style="margin-left: 5px">
              </el-switch>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:20px;height:16px;margin-right:10px;"
                          :src="yy9"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                每人每天允许预约场次：{{ site.roomMaxTimes }}场
              </p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;">
              <div style="width:22px;">
                <el-image style="width:20px;height:16px;margin-right:10px;"
                          :src="yy5"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:6px;margin-bottom:6px">
                同一时间段允许预约人数：{{ site.maxTimes }}人
              </p>
            </div>
            <div style="display:flex;margin-top:10px;margin-right:20px;margin-bottom:0px;line-height:1.1;">
              <div style="width:22px;">
                <el-image style="width:16px;height:16px;margin-right:10px;"
                          :src="yy10"
                          fit="fit">
                </el-image>
              </div>
              <p style="margin-top:0px;margin-bottom:6px;width:80%;word-wrap: break-word;overflow-wrap: break-word;">
                {{ site.tipInfo }}
              </p>
            </div>
            <div style="display:flex;height:40px;width:85%;line-height:0.3;justify-content:center;">
              <el-button @click="change_dvc(site)" type="text" size="small" icon="el-icon-edit"
                         style="margin-left:auto;color:#72767b;font-size:20px;"/>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
          style="height:80px;margin-right:1vw;margin-top:20px;padding:0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page="page"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
      <el-footer style="margin-bottom: 3px">
      </el-footer> <!--grid加底部去除遮挡-->
    </el-main>
  </el-container>
</template>

<script>
export default {
  name:"scene",
  data() {
    return {
      is_ble:false,
      pwr:true,
      paths:"/home/scene/ble",
      h_text:"预约设置",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      yy1:require('@/assets/yy1.png'),
      yy2:require('@/assets/yy2.png'),
      yy3:require('@/assets/yy3.png'),
      yy4:require('@/assets/yy4.png'),
      yy5:require('@/assets/yy5.png'),
      yy6:require('@/assets/yy6.png'),
      yy7:require('@/assets/yy7.png'),
      yy8:require('@/assets/yy8.png'),
      yy9:require('@/assets/yy9.png'),
      yy10:require('@/assets/yy10.png'),
      sites:[], /*{'name': 2, 'description': 1, "bj": "#EDEDED"}*/
      divStyle:{
        marginLeft:'0',
        marginTop:'0',
        maxHeight:window.innerHeight
      },
      tab_xz:'手动触发',
      li_Scene:[],
      scan_name:"",
      page:1,
      pageSize:10,
      total:0,
      tabData:[]
    };
  },
  methods:{ /*方法存放*/
    onXz() {
      console.log(this.tab_xz);
    },
    change_dvc(row) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsResvSetSon',
        query:{
          key:'change',
          id:row.id
          //name:row.name,
          //isAppointing:row.isAppointing,
          //startTime:row.startTime, /*预约起始时间*/
          //endTime:row.endTime, /*预约结束时间*/
          //onlyOwer:row.onlyOwer,
          //needApproval:row.needApproval,
          //needService:row.needService,
          //earlyTime:row.earlyTime, /*提前开门时间*/
          //earlyDay:row.earlyDay, /*提前预约*/
          //minEarlyDay:row.minEarlyDay, /*提前预约*/
          //timeGap:row.timeGap, /*时间段*/
          //maxNum:row.maxNum, /*最大人数*/
          //cleanTime:row.cleanTime, /*清洁间隔*/
          //maxTimes:row.maxTimes, /*同一时间段最多允许预约次数*/
          //roomMaxTimes:row.roomMaxTimes, /*每人天预约最多时间段*/
          //userMaxTimes:row.userMaxTimes,/*同一时间段同一人预约次数*/
          //isCare:row.isCare, /*是否需要填写人文关怀*/
          //isAttendNum:row.isAttendNum, /*是否需要填写参与人数*/
          //maxAttendNum:row.maxAttendNum, /*预约最多填写人数*/
          //sort:row.sort, /*房间排序*/
          //tipInfo:row.tipInfo /*提示*/
        }
      });
    },
    addScene() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsResvSetSon',
        query:{key:'add'}
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getScene();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getScene();
    },
    changeNotice(row,k) { /*每次新增房间内容都要新增*/
      const params = {
        id:row.id,
        name:row.name,
        isAppointing:row.isAppointing,
        openStartTime:this.parseToInt(row.startTime), /*预约起始时间*/
        openEndTime:this.parseToInt(row.endTime), /*预约结束时间*/
        onlyOwer:row.onlyOwer,
        needApproval:row.needApproval,
        earlyTime:row.earlyTime, /*提前开门时间*/
        earlyDay:row.earlyDay, /*提前预约*/
        timeGap:row.timeGap, /*时间段*/
        maxNum:row.maxNum, /*最大人数*/
        cleanTime:row.cleanTime, /*清洁间隔*/
        maxTimes:row.maxTimes, /*最大预约场次*/
        roomMaxTimes:row.roomMaxTimes, /*每人每天最大预约次数*/
        userMaxTimes:row.userMaxTimes, /*同一时间段允许次数*/
        tipInfo:row.tipInfo, /*提示*/
        needService:row.needService,/*是否需要服务*/
        isCare:row.isCare, /*是否需要填写人文关怀*/
        minEarlyDay:row.minEarlyDay, /*提前预约*/
        isAttendNum:row.isAttendNum, /*是否需要填写参与人数*/
        maxAttendNum:row.maxAttendNum, /*预约最多填写人数*/
        sort:row.sort, /*房间排序*/
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateRoomAppointInfo,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.getScene();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    parseToInt(li_str) { /*字符串转分钟*/
      if (li_str) {
        const arr = li_str.split(":");
        if (arr.length === 2) {
          const h = parseInt(arr[0]);
          const m = parseInt(arr[1]);
          return h * 60 + m;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    parseToTime(val) {
      if (val) {
        let h = `${parseInt(val / 60)}`.toString().padStart(2,'0') + ":";
        let m = `${parseInt(val % 60)}`.toString().padStart(2,'0');
        return h + m;
      } else {
        return "00:00";
      }
    },
    init_View() {
      let data = this.li_Scene;
      let li_d = [];
      let j = 1;
      for (let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          id:data[i]['id'],
          name:data[i]['name'],
          isAppointing:data[i]['isAppointing'], /*是否可预约*/
          startTime:this.parseToTime(data[i]['openStartTime']), /*预约起始时间*/
          endTime:this.parseToTime(data[i]['openEndTime']), /*预约结束时间*/
          earlyTime:data[i]['earlyTime'], /*提前开门时间*/
          earlyDay:data[i]['earlyDay'], /*提前预约*/
          minEarlyDay:data[i]['minEarlyDay'], /*提前预约*/
          timeGap:data[i]['timeGap'], /*时间段*/
          maxNum:data[i]['maxNum'], /*最大人数*/
          cleanTime:data[i]['cleanTime'], /*清洁间隔*/
          onlyOwer:data[i]['onlyOwer'], /*仅业主预约*/
          needApproval:data[i]['needApproval'], /*是否需要审批*/
          needService:data[i]['needService'], /*是否需要服务*/
          maxTimes:data[i].maxTimes, /*同一时间段最多允许预约次数*/
          roomMaxTimes:data[i].roomMaxTimes, /*每人天预约最多时间段*/
          userMaxTimes:data[i].userMaxTimes, /*同一时间段同一人预约次数*/
          isCare:data[i].isCare, /*是否需要填写人文关怀*/
          isAttendNum:data[i].isAttendNum, /*是否需要填写参与人数*/
          maxAttendNum:data[i].maxAttendNum, /*预约最多填写人数*/
          tipInfo:data[i]['tipInfo'], /*提示*/
          sort:data[i].sort, /*房间排序*/
          bj:"#EEF4FF"
        };
        li_d.push(d);
      }
      this.sites = li_d;
    },
    getScene() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getRoomList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_Scene = res.data.data["list"];
        try {
          if (this.li_Scene && this.li_Scene.length > 0) {
            this.init_View();
            this.total = res.data.data.total;
          } else {
            this.total = 0;
          }
        } catch (err) {
          this.total = 0;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取房间信息失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.getScene();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    // fil_tabData() {
    //   return this.sites.filter(item => {
    //     return !(this.scan_name && !item.name.includes(this.scan_name));
    //   });
    // },
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#scene {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
  overflow-y: auto; /*设置超出屏幕滚轮自动出现*/
}

.grid-box1 { /*表格式布局*/
  display: grid;
  grid-template-columns: repeat(auto-fill, 260px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 15px; /*行列间距*/
  row-gap: 15px;
  /*grid-template-rows: repeat(auto-fill, 300px); !*设置高度限制*!*/
}

.grid-item1 {
  border-radius: 8px 8px 8px 8px; /* 左上角、右上角、右下角、左下角 */
  background: linear-gradient(to bottom, #ffffff, #f2f2f2 50%, #d9d9d9 100%);
  box-shadow: 0 1px 6px #1D66DD, 0 0 10px rgba(0, 0, 0, 0.1) inset;
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/hs/resvSet.vue